 
                        <nb-card *ngIf="stream"  [nbSpinner]="loading" class="own-scroll">
                            <nb-card-header>
				<div style="display:flex">
                              <div  style="display:flex;   cursor:pointer;  margin-top: auto;
    margin-bottom: auto;" 	[class.unvisiblePanelLabel]="panelVisibility.isUnvisible('saleAccess')"	   (click)="panelVisibility.toggleVisibility('saleAccess')">Платний доступ</div>  
<div  style="display:flex; margin-left:auto; cursor:pointer;  margin-top: auto;
    margin-bottom: auto;">
	
				   <nb-toggle
					 [disabled]="!authService.currentTariff?.saleAvailable"
				     labelPosition="left"
				      [(checked)]="saleOn" 
				      (checkedChange)="toggleSaleOn()" 
				      status="primary">
				      <span *ngIf="saleOn">Увімкнено</span>
				      <span *ngIf="!saleOn">Вимкнено</span>
				    </nb-toggle>

   </div>
				</div>
                            </nb-card-header>
                            <nb-card-body  *ngIf="!panelVisibility.isUnvisible('saleAccess')" [@visibilityPanelAnimation]  >
 
		<div>
			<label>Ціна</label>
 			<div style="display:flex;     align-items: center;">

			<div style="display:flex; flex:1">
			<input type="number" class="priceInput" [disabled]="!saleOn || !authService.currentTariff?.saleAvailable" (keyUp.enter)="priceChange()" [(ngModel)]="price"  min="0" nbInput fullWidth />

	 </div>
		<div style="display:flex; margin-left:10px"> грн. </div>
                              
		<div style="display:flex; margin-left:10px"> <button  [disabled]="!saleOn || price === stream.price || price < 1" status="primary" (click)="priceChange()" [disabled]="!authService.currentTariff?.saleAvailable" nbButton>Зберегти</button> </div>

                              </div>
     </div>
                            </nb-card-body>
                            
                            </nb-card>
 
  


 
